import type { PropsWithChildren } from "react"

import { LanguageSelector } from "@/components/commons/language-selector"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"

import { EnvironmentMessage } from "./environment-message"

export const Header = ({ children }: PropsWithChildren) => {
  return (
    <div className="sticky top-0 z-40">
      <header
        className="flex h-14 shrink-0 items-center justify-between border-b transition-all duration-200"
        style={{
          backgroundColor: "var(--whitelabel-background)",
        }}
      >
        <div className="flex items-center gap-3 px-4">
          <SidebarTrigger className="h-8 w-8 rounded-lg text-primary-foreground hover:bg-primary-foreground/10" />
          <Separator
            orientation="vertical"
            className="h-5"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          />
          <div className="flex items-center gap-2 text-sm font-medium text-primary-foreground">
            {children}
          </div>
        </div>

        <div className="flex items-center gap-2 px-4 text-primary-foreground">
          <LanguageSelector />
        </div>
      </header>
      <EnvironmentMessage />
    </div>
  )
}
